import type { ReactNode } from "react";
import { AuthShell } from "@/components/auth/auth-shell";
import { BrandPanel } from "@/components/auth/brand-panel";
import type { BrandPage } from "@/components/auth/brand-storytelling";

interface ErrorPageShellProps {
  page: Extract<BrandPage, "404" | "403" | "500">;
  children: ReactNode;
}

// Reuses the split-panel layout from auth pages for visual consistency.
// Brand panel left (lg+), error content right.
export function ErrorPageShell({ page, children }: ErrorPageShellProps) {
  return (
    <AuthShell>
      <BrandPanel page={page} />
      <div id="main-content" className="flex min-h-full items-center justify-center bg-[var(--background)] px-4 py-10 lg:px-10">
        <div className="w-full max-w-md">{children}</div>
      </div>
    </AuthShell>
  );
}
